import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { assignDevices } from '../../store/action/device.action'
import { Checkbox, Button, Row, Col, Popover, Card, List, Modal } from 'antd'
import { EditOutlined, PlusCircleFilled } from '@ant-design/icons'
import serviceInterface from '../../services/service.interface'
import '../../css/regimen.scss'
import moment from 'moment'
const AddForm = (props) => {
  const [open, setOpen] = useState(false)

  const hide = () => {
    setOpen(false)
  }
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen)
  }

  var handleRowSelect = (form) => {
    try {
      // Calculate diff safely
      const surgeryDate = moment(props.surgerydate)
      if (!surgeryDate.isValid()) {
        console.error('Invalid surgery date:', props.surgerydate)
        return
      }

      const diff = moment().diff(surgeryDate, 'days') + 1

      props.handleRowSelect({
        ...form,
        editnew: true,
        formid: form._id,
        schedule: [surgeryDate.add(diff, 'd').day()],
        scheduletype: 'weekly',
        startdate: diff,
        enddate: diff,
        skiponsurgerydate: true,
      })

      // Close popover after successfully adding
      setOpen(false)
    } catch (error) {
      console.error('Error adding form:', error)
    }
  }

  const node = (
    <Card
      className='regContainer'
      style={{
        height: '200px',
        overflow: 'auto',
      }}
    >
      {props.forms?.map((form, i) => {
        return (
          <Row key={i} className={'exerRow'}>
            <Col style={{ width: '100%' }}>
              <Row
                className='exerSubheader divider'
                onClick={() => handleRowSelect(form)}
              >
                <Col flex={'90%'}>{form?.shortname}</Col>
                <Col flex={'10%'}>
                  <PlusCircleFilled />
                </Col>
              </Row>
            </Col>
          </Row>
        )
      })}
    </Card>
  )

  return (
    <Popover
      content={node}
      title='Add Form'
      trigger='click'
      placement='top'
      overlayStyle={{
        minWidth: '100px',
        width: '20vw',
      }}
      // open={open}
      // onOpenChange={handleOpenChange}
      visible={open}
      onVisibleChange={handleOpenChange}
    >
      <Button
        id={'addform'}
        style={{ margin: '10px' }}
        className='nextBtn'
        type='primary'
      >
        Add Form
      </Button>
    </Popover>
  )
}

export default AddForm
